import script from "./CLoadingIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./CLoadingIndicator.vue?vue&type=script&setup=true&lang=ts"

import "./CLoadingIndicator.vue?vue&type=style&index=0&id=3e0814a6&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0814a6"]])

export default __exports__